// extracted by mini-css-extract-plugin
export default {"languageSelect":"w1OMLcgboA_QKqSGRx64","submitButton":"d_vh5blTgRrLxp_mghVM","termsContainer":"oyoyZtpMgSM6OL4ISbwW","termsLink":"jpf_y3iXxouvZxHtPeJM"};